import React from "react";
import './comp6_1.css';

class Comp6_1 extends React.Component {
  render() {
    return (
      <div className="comp6_1" data-part-id="box" href="">
        <a
          className="comp6_1_1"
          data-part-id="cardLink"
          href=""
        >
          <h4 className="comp6_1_2" data-part-id="text" size={1}>
            Using GANs and Genetic Algorithms to generate video game levels
          </h4>
          <p className="comp6_1_3" data-part-id="text" size={3}>
            GAN is trained to generate levels (for 
Mario, Zelda, Sokoban, etc) as if they were images.
          </p>
          <div className="comp6_1_4" data-part-id="flex">
            <div className="comp6_1_5" data-part-id="flex">
              <span className="comp6_1_7" data-part-id="avatar">
                <img
                  alt="Photo of Pedro Duarte"
                  className="comp6_1_10"
                  data-part-id="image"
                  src=""
                />
              </span>
              <p className="comp6_1_8" data-part-id="text" size={2}>
                Nichita Uțiu
              </p>
            </div>
            <div className="comp6_1_6" data-part-id="box">
              <p className="comp6_1_9" data-part-id="text" size={2}>
                May ‘11
              </p>
            </div>
          </div>
        </a>
      </div>
    );
  }
}

export default Comp6_1;
